import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import { useTableStyles } from '../../common/use-table-styles'
import { SelectedVersion } from '../../layout/VersionsSelector'

type Props = {
  versions: SelectedVersion[]
}
export function CostsTableVersionNameRow({
  versions,
}: Props): React.ReactElement {
  const classes = useTableStyles()
  return (
    <TableRow>
      <TableCell className={classes.titleHeaderCell} />
      {versions.map((version) => (
        <TableCell
          className={classes.versionHeaderCell}
          key={version.id}
          align="center"
        >
          {version.name}
        </TableCell>
      ))}
    </TableRow>
  )
}
